import {Observable} from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel} from "../../../shared";
import { AgentTaskReportResponseDto } from '../../../../data-transfer-objects/alg/cc/agent-task-report-response-dto.model';

@Injectable({ providedIn: 'root' })
export class AgentTaskReport extends BaseApiTemplateService<AgentTaskReportResponseDto> {
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'reports/agent-report';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'reports/agent-report';
    this.httpClient = theHttp;
    }

    // ** DEPRECATED and will be removed (replaced by getAgentReportUpdatedApi)**
    getAgentReport(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<AgentTaskReportResponseDto>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      const UrlByCriteria = this.apiUrl + '?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<AgentTaskReportResponseDto>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
    }

    // ** Updated Version
    getAgentReportUpdatedApi(pagination: Pagination, visa: ApiVisa, appletGuid: string): Observable<PagingResponseModel<AgentTaskReportResponseDto>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      const UrlByCriteria = this.apiUrl + '?appletGuid=' + appletGuid + '&' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<AgentTaskReportResponseDto>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
    }


    // ** DEPRECATED and will be removed (replaced by exportAgentReportCsvAsBlobUpdatedApi)**
    async exportAgentReportCsvAsBlob(pagination: Pagination, authorization: string, apiVisa: ApiVisa){
      const CSV_URL = this.apiUrl + '/export/csv?' + pagination.getQueryKeyValues();
      const headers = new HttpHeaders({ "authorization": authorization, "tenantCode" : apiVisa.tenantCode });
      const fileBlob = await this.httpClient
        .get(CSV_URL, { headers, responseType: 'blob' })
        .toPromise();
      return fileBlob;
    }
    
    // ** Updated Version
    async exportAgentReportCsvAsBlobUpdatedApi(pagination: Pagination, authorization: string, apiVisa: ApiVisa, appletGuid: string){
      const CSV_URL = this.apiUrl + '/export/csv?appletGuid=' + appletGuid + "&" + pagination.getQueryKeyValues();
      const headers = new HttpHeaders({ "authorization": authorization, "tenantCode" : apiVisa.tenantCode });
      const fileBlob = await this.httpClient
        .get(CSV_URL, { headers, responseType: 'blob' })
        .toPromise();
      return fileBlob;
    }  
}
